import React from "react";

function InputComp(props) {
  return (
    <div>
      <input
        className="w-full bg-[#F5F7F9] px-7 py-5 outline-none border-none rounded-2xl text-[#8f8f8f]"
        type={props.type}
        onChange={props.onChange}
        value={props.value}
        placeholder={props.label}
        required={props.required}
      />
    </div>
  );
}

export default InputComp;
